import script from "./Widget.vue?vue&type=script&setup=true&lang=js"
export * from "./Widget.vue?vue&type=script&setup=true&lang=js"

import "./Widget.vue?vue&type=style&index=0&id=74b34db0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74b34db0"]])

export default __exports__